import { render, staticRenderFns } from "./VacanciesContactList.vue?vue&type=template&id=5a5411c8&scoped=true"
import script from "./VacanciesContactList.vue?vue&type=script&lang=js"
export * from "./VacanciesContactList.vue?vue&type=script&lang=js"
import style0 from "./VacanciesContactList.vue?vue&type=style&index=0&id=5a5411c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5411c8",
  null
  
)

export default component.exports